import clsx from 'clsx';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { createUrl } from '../../../../utils';
import type { SortFilterItem } from '../../../../lib/constants';
import type { PathFilterItem } from './index';

type ListItem = SortFilterItem | PathFilterItem;

function PathFilterItemComponent({ item }: { item: PathFilterItem }) {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const active = location.pathname === item.path;
  const newParams = new URLSearchParams(searchParams.toString());
  const DynamicTag = active ? 'p' : Link;

  newParams.delete('q');

  return (
    <li className="mt-2 flex text-black dark:text-white" key={item.title}>
      <DynamicTag
        to={createUrl(item.path, newParams)}
        className={clsx(
          'w-full text-sm underline-offset-4 hover:underline dark:hover:text-neutral-100',
          {
            'underline underline-offset-4': active
          }
        )}
      >
        {item.title}
      </DynamicTag>
    </li>
  );
}

function SortFilterItemComponent({ item }: { item: SortFilterItem }) {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const active = searchParams.get('sort') === item.slug;
  const q = searchParams.get('q');
  const newParams = new URLSearchParams();
  if (q) newParams.set('q', q);
  if (item.slug && item.slug.length) newParams.set('sort', item.slug);
  
  const href = createUrl(location.pathname, newParams);
  const DynamicTag = active ? 'p' : Link;

  return (
    <li className="mt-2 flex text-sm text-black dark:text-white" key={item.title}>
      <DynamicTag
        to={href}
        className={clsx('w-full hover:underline hover:underline-offset-4', {
          'underline underline-offset-4': active
        })}
      >
        {item.title}
      </DynamicTag>
    </li>
  );
}

export function FilterItem({ item }: { item: ListItem }) {
  return 'path' in item ? <PathFilterItemComponent item={item} /> : <SortFilterItemComponent item={item} />;
}
